import {collection, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {OutletReferenceData} from "../../pos/outlet/outlet.data";
import {CustomObjectReferenceData} from "../../custom-objects/custom-object/custom-object.data";

export class AccessRoleAuthorisationData extends EntityData<AccessRoleAuthorisationData> {
    @field groupType: string;
    @field name: string;

    get key(): string{
        return AccessRoleAuthorisationData.createKey(this.groupType, this.name);
    }

    static createKey(groupType: string, name: string): string {
        return groupType + ";" + name;
    }
}

export class AccessRoleData extends EntityData<AccessRoleData> {
    @identifier accessRoleId: number;
    @field name: string;
    @field details: string;

    @field universal: boolean = true;
    @collection(OutletReferenceData) outlets: OutletReferenceData[];
    @collection(CustomObjectReferenceData) customObjects: CustomObjectReferenceData[];

    @collection(AccessRoleAuthorisationData) authorisations: AccessRoleAuthorisationData[];
}

export class AccessRoleReferenceData extends EntityData<AccessRoleReferenceData> {
    @identifier accessRoleId: number;
    @field name: string;
}
